const MAX_RANGE_DAYS = 31;

/** Return the trimmed search term as-is (no + stripping, no digit filtering). */
export function normalizeSearchNumber(raw) {
  return (raw || "").trim();
}

/**
 * Returns a validation error message string, or null if there is no error.
 * Only runs if all three arguments are non-empty (otherwise the form is just
 * incomplete, not erroneous, so null is returned silently).
 */
export function computeValidationError(normalizedNumber, fromTime, toTime) {
  if (!normalizedNumber || !fromTime || !toTime) return null;
  const start = new Date(fromTime).getTime();
  const end = new Date(toTime).getTime();
  if (end <= start) return "End time must be after start time";
  if (end - start > MAX_RANGE_DAYS * 24 * 3600 * 1000) return "Date range must not exceed 31 days";
  return null;
}

/** True when a search request can be submitted. */
export function isReadyToSearch(normalizedNumber, fromTime, toTime) {
  return (
    !!normalizedNumber &&
    !!fromTime &&
    !!toTime &&
    computeValidationError(normalizedNumber, fromTime, toTime) === null
  );
}
